import { HttpInterceptorFn } from '@angular/common/http';

export const apiAuthInterceptor: HttpInterceptorFn = (request, next) => {
  const token = sessionStorage.getItem('mercure.api.accessToken');
  if (!token || request.url.endsWith('/api/v1/auth/login') || request.url.endsWith('/api/v1/auth/refresh') || request.url.endsWith('/api/v1/auth/logout')) return next(request);
  return next(request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
